import {
  TIMELINE_LABORATORY_PATH,
  TIMELINE_MATERNAL_INFANT_PATH,
  TIMELINE_GENERAL_PATH,
  TIMELINE_RADIOLOGY_PATH,
  TIMELINE_ONCOLOGY_PATH
} from '.'
import { EMedicalViews } from '~/interfaces'

export const medicalViewRoutesPath = {
  [EMedicalViews.GENERAL]: TIMELINE_GENERAL_PATH,
  [EMedicalViews.MATERNAL_INFANT]: TIMELINE_MATERNAL_INFANT_PATH,
  [EMedicalViews.LABORATORY]: TIMELINE_LABORATORY_PATH,
  [EMedicalViews.RADIOLOGY]: TIMELINE_RADIOLOGY_PATH,
  [EMedicalViews.ONCOLOGY]: TIMELINE_ONCOLOGY_PATH
}
